import Vue from 'vue'
import Vuex from 'vuex'
import options from './options'

Vue.use(Vuex)

const state = {
  selectOptions: options,
  choosed: [],
  results: [],
  appear: [],
  name: ''
}
const getters = {
  getPreOptions: state => { //所有选项
    return state.selectOptions.preOptions
  },
  getAfterOptions: state => { //所有选项
    return state.selectOptions.afterOptions
  },
  getChoosed: state => { //选择选项
    return state.choosed
  },
  getAppear: state => {
    return state.appear
  },
  getResults: state => {
    return state.results
  },
  getName: state => {
    return state.name
  },
  getEnglishSentence: state => {
    return state.selectOptions.englishSentence
  },
  getSentenceOne: state => {
    return state.selectOptions.sentenceOne
  },
  getLongEnglish: state => {
    return state.selectOptions.longEnglish
  }
}
const actions = {
}
const mutations = {
  setOptions(state, options) {
    state.choosed.push(...options)
  },
  setResults(state, result) {
    state.results = result
  },
  setAppear(state, appear) {
    state.appear.push(...appear)
  },
  updateAppear(state, value) {
    let index = state.appear.indexOf(value)
    state.appear.splice(index, 1)
  },
  clearAppear(state) {
    state.appear = []
  },
  setName(state, name) {
    state.name = name
  },
  clearAll(state) {
    state.choosed = []
    state.results = [],
    state.appear = [],
    state.name = ''
  }
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})